import { Component } from "react";

// App-wide crash guard. Prevents a single render error from white-screening the
// whole SPA — shows a branded fallback with a recovery action instead.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("RecoverOS UI crash:", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.assign("/dashboard");
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        style={{ fontFamily: "'Inter', sans-serif" }}
        className="min-h-screen flex items-center justify-center bg-slate-50 px-6"
      >
        <div className="max-w-md w-full text-center border border-slate-200 bg-white p-10 rounded-sm">
          <div className="mx-auto h-14 w-14 rounded-full bg-[#0B3D91]/10 flex items-center justify-center">
            <span className="text-2xl font-black text-[#0B3D91]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>!</span>
          </div>
          <h1 className="mt-5 text-2xl font-extrabold text-slate-950" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            Something went wrong
          </h1>
          <p className="mt-3 text-sm text-slate-600">
            An unexpected error interrupted RecoverOS. Your data is safe. Please reload to continue — if it keeps happening, email{" "}
            <a href="mailto:support@recoveros.in" className="font-semibold text-[#0B3D91] hover:underline">support@recoveros.in</a>.
          </p>
          <button
            onClick={this.handleReload}
            data-testid="error-boundary-reload"
            className="mt-7 w-full bg-[#0B3D91] text-white rounded-sm px-6 py-3 font-semibold hover:bg-[#0a3578] transition-colors"
          >
            Reload RecoverOS
          </button>
        </div>
      </div>
    );
  }
}
